import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/nprogress/styles.css';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import AppContextProvider from './contexts/AppContext';
import ToastContainer from './components/ToastContainer';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import RequestLoan from './pages/RequestLoan';
import LoanRepayment from './pages/LoanRepayment';
import KYC from './pages/KYC';
import Profile from './pages/Profile';
import Account from './pages/Account';
import NotFound from './pages/NotFound';
import PaystackDirectDebitCallback from './pages/PaystackDirectDebitCallback';

import './index.scss'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmail />,
  },
  {
    path: '/paystack/direct-debit/callback',
    element: <PaystackDirectDebitCallback />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/request-loan" replace />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'account',
        element: <Account />,
      },
      {
        path: 'request-loan',
        element: <RequestLoan />,
      },
      {
        path: 'loan-repayment',
        element: <LoanRepayment />,
      },
      {
        path: 'loan-history',
        element: <Dashboard />,
      },
      {
        path: 'kyc',
        element: <KYC />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

function App() {
  return (
    <MantineProvider
      theme={{
        primaryColor: 'green',
        colors: {
          green: [
            '#E8F5E9',
            '#C8E6C9',
            '#A5D6A7',
            '#81C784',
            '#66BB6A',
            '#699269',
            '#558B2F',
            '#33691E',
            '#1B5E20',
            '#0D3E1F',
          ],
        },
      }}
    >
      <Notifications />
      <ToastProvider>
        <AuthProvider>
          <AppContextProvider>
            <RouterProvider router={router} />
          </AppContextProvider>
        </AuthProvider>
        <ToastContainer />
      </ToastProvider>
    </MantineProvider>
  );
}

export default App;
